<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4 class="margin-b-24">Afbeeldingen</h4>
		
		<img :src="url">
		
	</div>
</template>

<script>

export default {
	data() {
		return {
			
		}
	},
	props: {
		url: {
			type: String
		}
	}
}
</script>